import { INaeEditSettings } from "@newageerp/nae-react-ui/dist/interfaces";

export const NaeEditFields: INaeEditSettings[] = [
];